module.exports = __webpack_public_path__ + "static/media/Nyx Assassin.a4cff0f5.png";